// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent, MappedComponentProperties } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';
import type { LoyaltyWidgetContainerProps } from './LoyaltyWidgetContainer.types';

export const LoyaltyWidgetContainer = dynamic(() =>
  import('./LoyaltyWidgetContainer').then(mod => mod.LoyaltyWidgetContainer)
);

export const LoyaltyWidgetContainerConfig = {
  emptyLabel: 'Loyalty Widget Container',
  resourceType: `mi-aem-account/components/content/loyaltywidgetcontainer`,
  isEmpty: (_props: MappedComponentProperties) => {
    const componentProps = _props as unknown as LoyaltyWidgetContainerProps;
    // Always render in AEM author mode so authors can place inner widgets
    if (componentProps?.isAuthorMode) return false;
    const title = componentProps?.title;
    return !(typeof title === 'string' && title.trim().length > 0);
  },
};

export const LoyaltyWidgetContainerEditable = (props: LoyaltyWidgetContainerProps) => {
  return (
    <EditableComponent config={LoyaltyWidgetContainerConfig} {...props}>
      <LoyaltyWidgetContainer {...props} />
    </EditableComponent>
  );
};
